import { Locale } from '@mai-team-amusement/core';
import type { AppNamespace, LeafKey } from '@mai-team-amusement/i18n';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { enUs, type FixedAssetResources } from './en-US.js';
import { ja } from './ja.js';
import { zhHans } from './zh-Hans.js';
import { zhHant } from './zh-Hant.js';

export const FIXED_ASSET_NAMESPACE = 'fixedAsset';

export const fixedAssetResources: Record<Locale, FixedAssetResources> = {
  [Locale.ZhHans]: zhHans,
  [Locale.ZhHant]: zhHant,
  [Locale.EnUs]: enUs,
  [Locale.Ja]: ja,
};

export const fixedAssetNamespace: AppNamespace = {
  name: FIXED_ASSET_NAMESPACE,
  resources: fixedAssetResources,
};

export type FixedAssetKey = LeafKey<FixedAssetResources>;

export type FixedAssetTranslate = (
  key: FixedAssetKey,
  values?: Readonly<Record<string, string | number>>,
) => string;

/** Type-checked translator for this app's namespace. */
export function useAssetT(): FixedAssetTranslate {
  const { t } = useTranslation(FIXED_ASSET_NAMESPACE);
  return useCallback<FixedAssetTranslate>((key, values = {}) => t(key, values), [t]);
}
